import { fetchNotification, fetchNotifications } from '../queries/notifications.queries';

import { useQuery } from '@tanstack/react-query';

export const useNotifications = () => {
    return useQuery({
        queryKey: ['notifications'],
        queryFn: fetchNotifications,
    });
};

export const useNotification = (id: number) => {
    return useQuery({
        queryKey: ['notification', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchNotification(id);
        },
    });
};
